import { FC } from 'react';
import { Box } from '@mui/material';
import MainLayout from 'src/pages/private';

const ProductLogs: FC = () => {
  return (
    <MainLayout title="Product Logs">
      <Box></Box>
    </MainLayout>
  );
};

export default ProductLogs;
